import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import React, { ReactElement } from "react";

interface TaskInfoProps {
  description: string;
  meaning: string;
  name: string;
}

const TaskInfo = (props: TaskInfoProps): ReactElement => {
  const { description, meaning, name } = props;

  return (
    <Accordion
      disableGutters
      sx={{
        marginBottom: 3,
        marginTop: 1,
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "none",
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          {name} · {meaning}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {description}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
};

export default TaskInfo;
